import React from 'react';
import { Grid, Typography } from '@mui/material';

interface Props {
    offer: any;
}

const ProfilePartial = ({offer}: Props) => {

    return (
        <Grid container rowSpacing={2} columns={{ xs: 4 }} sx={{p: '1rem 1.5rem'}}>
            <Grid item xs={1}><Typography variant="h5">Niveau d'étude</Typography></Grid>
            <Grid item xs={3}>{offer.applicant_degree}</Grid>
            <Grid item xs={1}><Typography variant="h5">Niveau d'expérience</Typography></Grid>
            <Grid item xs={3}>{offer.applicant_experience}</Grid>
            <Grid item xs={1}><Typography variant="h5">Compétence spécifique</Typography></Grid>
            <Grid item xs={3}>{offer.applicant_qualifications}</Grid>
            <Grid item xs={1}><Typography variant="h5">Description du profile</Typography></Grid>
            <Grid item xs={3}>{offer.applicant_profile}</Grid>
        </Grid>
    );
};

export { ProfilePartial };